import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Personalization from '../../components/Personalization';
import { fetchInfoFromVersionColor } from '../../actions/personalization';

const PersonalizationContainer = ({ children, ...props }) => {
    const dispatch = useDispatch(); 
    const { personalization } = useSelector(state => ({
        personalization: state.personalization
    }));

    const fetchVersionInfo = (tipo, modelo, version, anio) => {
        dispatch(fetchInfoFromVersionColor(tipo, modelo, version, anio));
    }

    return (
        <Personalization 
            car={personalization} 
            fetchVersionInfo={fetchVersionInfo}
            {...props}
        >
            {children}
        </Personalization>
    );
};

export default PersonalizationContainer;
